import { VehicleFuelType } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";

export type VehicleSpawnInfo = {
  vehicleId: number;
  name: string;
  image: string;
  plateNumber: string;
  fuelType: VehicleFuelType;
  accessType: VehicleAccessType;
};

export enum VehicleAccessType {
  All = "all",
  Personal = "personal",
  Rental = "rental",
  Shared = "shared",
  Family = "family",
  Commercial = "commercial",
}
